import { Component, Input, OnInit } from '@angular/core';
import { filter, map } from 'rxjs/operators';

import { AdvancedPlatformsActions } from '../../../../../state-management/advanced-platforms/advanced-platforms.action';
import { PlatformsIds } from '../../../../../services/advanced-platforms.service';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-custom-links-wrapper',
  templateUrl: './custom-links-wrapper.component.html',
  styleUrls: ['./custom-links-wrapper.component.scss']
})
export class CustomLinksWrapperComponent implements OnInit {
  
  public toroTraderSubscriptionData = null;
  public homeBrokerClassicSubscriptionData = null
  public userHasToroTrader: boolean = false;

  private disposableSubscriptions: Subscription[] = [];

  constructor(private store: Store<any>) { }

  ngOnInit() {
    this.initializeSubscriptions()
        .initializeDispatchs()
  }

  public ngOnDestroy() {
    this.disposableSubscriptions.forEach((subscription) => {
        if (subscription) subscription.unsubscribe();
    });
  }

  private initializeSubscriptions() {
    this.disposableSubscriptions.push(
      this.store.select(({advancedPlatforms}) => advancedPlatforms.list)
        .pipe(
          map((item) => this.isToroTraderOrHomeBrokerClassic(item)),
        )
        .subscribe((platforms) => {
          this.setPlatformsLocalData(platforms)
              .setSubscriptionsLocalData();
        })
    )
    return this;
  }

  private isToroTraderOrHomeBrokerClassic(item: any): any {
    return item.filter(p => p.id === PlatformsIds.ToroTraderProfit || p.id === PlatformsIds.HomeBrokerClassic);
  }

  private initializeDispatchs() {
    this.store.dispatch({ type: AdvancedPlatformsActions.getPlatforms });
    this.store.dispatch({ type: AdvancedPlatformsActions.getSubscribes });
    return this;
  }

  private setPlatformsLocalData(platforms) {
    this.toroTraderSubscriptionData = platforms.find(p => p.id === PlatformsIds.ToroTraderProfit)
    this.homeBrokerClassicSubscriptionData = platforms.find(p => p.id === PlatformsIds.HomeBrokerClassic)
    return this;
  }

  private setSubscriptionsLocalData() {
    this.userHasToroTrader = this.toroTraderSubscriptionData && this.toroTraderSubscriptionData.subscriptionStatus;
  }

  homeBrokerCustomClickAction = () => {
      window.location.href = '/plataformas/acessar-homebroker';
  }
}
